// This file should only contain action type constants.

export const SET_TITLE = 'SET_TITLE';
export const SET_HIGHLIGHTED_ATTRS_CONFIG = 'SET_HIGHLIGHTED_ATTRS_CONFIG';
export const SET_VEHICLE = 'SET_VEHICLE';
export const VCDA_ERROR = 'VCDA_ERROR';
